import { Link } from "react-router-dom";

export function SiteFooter() {
	return (
		<footer className="relative z-20 border-t border-zinc-950/5 bg-surface/80 px-4 py-4 text-sm text-fg-muted backdrop-blur-md dark:border-white/5">
			<div className="mx-auto flex max-w-5xl flex-col gap-3">
				<div className="grid grid-cols-1 gap-3 text-center sm:grid-cols-2 sm:items-center sm:text-left">
					<p className="min-w-0">
						© 2026 Kartenwerk · a product by{" "}
						<a
							href="https://mattschach.com"
							target="_blank"
							rel="noopener noreferrer"
							className="font-medium text-teal-600 hover:text-teal-500 dark:text-teal-400 dark:hover:text-teal-300"
						>
							mattschach.com
						</a>
					</p>
					<nav className="flex flex-wrap justify-center gap-x-4 gap-y-1 sm:justify-end">
						<Link
							to="/impressum"
							className="font-medium text-teal-600 hover:text-teal-500 dark:text-teal-400 dark:hover:text-teal-300"
						>
							Impressum
						</Link>
						<Link
							to="/datenschutz"
							className="font-medium text-teal-600 hover:text-teal-500 dark:text-teal-400 dark:hover:text-teal-300"
						>
							Datenschutz
						</Link>
					</nav>
				</div>
				<p className="text-center font-mono text-xs text-fg-muted/70">
					v{__APP_VERSION__}
				</p>
			</div>
		</footer>
	);
}
